import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TransferEnviromentService } from './transferEnviroment.service';
import { IEnviroment } from '../interfaces/ienviroment';

import { Questionary } from '../models/questionary.model';
import { BaseService } from '@n3/ng-api-base-kit';

/**
 * @name IQuestionaryGet
 *
 * @param *id - Идентификатор организации 
 */
export interface IQuestionaryGet {
    id: string;
}

/**
 * @name IQuestionarySoftDelete
 *
 * @param *id - Идентификатор анкеты 
 */
export interface IQuestionarySoftDelete {
    id: string;
}

/**
 * @name IQuestionaryRestore
 *
 * @param *id - Идентификатор анкеты 
 */
export interface IQuestionaryRestore {
    id: string;
}

/**
 * @name IQuestionarySave
 *
 * @param *body -   
 */
export interface IQuestionarySave {
    body: Questionary;
}

/**
 * @name IQuestionaryList
 *
 * @param p_limit - Количество записей 
 * @param p_page - Страница выдачи 
 * @param p_search - Поисковая строка 
 * @param p_levels - Уровень образования по справочнику 
 * @param p_disciplines - Дисциплина по справочнику 
 * @param p_education_stages - Этапы образования 
 * @param p_difficulties - Сложность 
 * @param p_event_levels - Уровень события по справочнику 
 * @param p_tags - Ссылка на тэг (Тема по справочнику) 
 * @param p_deleted - Показывать удаленные 
 */
export interface IQuestionaryList {
    p_limit?: number;
    p_page?: number;
    p_search?: string;
    p_levels?: number[];
    p_disciplines?: number[];
    p_education_stages?: number[];
    p_difficulties?: number[];
    p_event_levels?: number[];
    p_tags?: number[];
    p_deleted?: boolean;
}



@Injectable()
export class TestingService {
    private enviroment: IEnviroment;
    constructor(private base: BaseService, private enviromentService: TransferEnviromentService) { 
        this.enviroment = enviromentService.getEnviroment();
    }

    /**
     * Получает анкету по ее id
     * @method
     * @name questionaryGet
     * @param data - объект с данными типа IQuestionaryGet
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public questionaryGet(
        data: IQuestionaryGet,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/testing/questionary/get/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }
    /**
     * Удаляет Анкета, по id
     * @method
     * @name questionarySoftDelete
     * @param data - объект с данными типа IQuestionarySoftDelete
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public questionarySoftDelete(
        data: IQuestionarySoftDelete,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/testing/questionary/soft-delete/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Восстанавливает анкету по id
     * @method
     * @name questionaryRestore
     * @param data - объект с данными типа IQuestionaryRestore
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public questionaryRestore(
        data: IQuestionaryRestore,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/testing/questionary/restore/{id}'
        .replace(/{id}/ig, (typeof data.id !== 'string')
         ? JSON.stringify(data.id)
         : data.id);
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        const queryBody = '';
        return this.base.send('delete', path, queryBody, headers, search);
    }
    /**
     * Сохраняет анкету
     * @method
     * @name questionarySave
     * @param data - объект с данными типа IQuestionarySave
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public questionarySave(
        data: IQuestionarySave,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/testing/questionary/save';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        let queryBody = '';
        queryBody += JSON.stringify(this.base.unnulling(data.body));
        return this.base.send('post', path, queryBody, headers, search);
    }
    /**
     * Получает анкет в постраничном разбиении
     * @method
     * @name questionaryList
     * @param data - объект с данными типа IQuestionaryList
     * @param form - не обазательный параметр, ссылка на форму, для подсветки ошибок
     */
    public questionaryList(
        data: IQuestionaryList,
        form?: any
    ): Observable<any> {
        const path = ((typeof this.enviroment.host !== 'undefined') ? this.enviroment.host : '') +
        '/testing/questionary/list';
        const headers: Array<{name: string, value: string | string[]}> = [];
        headers.push({name: 'Access-Control-Allow-Origin', value: '*'});       
        headers.push({name: 'X-Requested-With', value: 'XMLHttpRequest'});
        headers.push({name: 'X-JWT-Token', value: (this.enviromentService.getToken() || '')});
        const search: Array<{param: string, value: string}> = [];
        if (typeof data.p_limit !== 'undefined' && data.p_limit !== null ) {
            if (Array.isArray(data.p_limit)) {
                data.p_limit.map((item) => {
                    search.push({param: 'p_limit[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_limit', value: '' + data.p_limit});
            }
        }
        if (typeof data.p_page !== 'undefined' && data.p_page !== null ) {
            if (Array.isArray(data.p_page)) {
                data.p_page.map((item) => {
                    search.push({param: 'p_page[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_page', value: '' + data.p_page});
            }
        }
        if (typeof data.p_search !== 'undefined' && data.p_search !== null ) {
            if (Array.isArray(data.p_search)) {
                data.p_search.map((item) => {
                    search.push({param: 'p_search[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_search', value: '' + data.p_search});
            }
        }
        if (typeof data.p_levels !== 'undefined' && data.p_levels !== null ) {
            if (Array.isArray(data.p_levels)) {
                data.p_levels.map((item) => {
                    search.push({param: 'p_levels[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_levels', value: '' + data.p_levels});
            }
        }
        if (typeof data.p_disciplines !== 'undefined' && data.p_disciplines !== null ) {
            if (Array.isArray(data.p_disciplines)) {
                data.p_disciplines.map((item) => {
                    search.push({param: 'p_disciplines[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_disciplines', value: '' + data.p_disciplines});
            }
        }
        if (typeof data.p_education_stages !== 'undefined' && data.p_education_stages !== null ) {
            if (Array.isArray(data.p_education_stages)) {
                data.p_education_stages.map((item) => {
                    search.push({param: 'p_education_stages[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_education_stages', value: '' + data.p_education_stages});
            }
        }
        if (typeof data.p_difficulties !== 'undefined' && data.p_difficulties !== null ) {
            if (Array.isArray(data.p_difficulties)) {
                data.p_difficulties.map((item) => {
                    search.push({param: 'p_difficulties[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_difficulties', value: '' + data.p_difficulties});
            }
        }
        if (typeof data.p_event_levels !== 'undefined' && data.p_event_levels !== null ) {
            if (Array.isArray(data.p_event_levels)) {
                data.p_event_levels.map((item) => {
                    search.push({param: 'p_event_levels[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_event_levels', value: '' + data.p_event_levels});
            }
        }
        if (typeof data.p_tags !== 'undefined' && data.p_tags !== null ) {
            if (Array.isArray(data.p_tags)) {
                data.p_tags.map((item) => {
                    search.push({param: 'p_tags[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_tags', value: '' + data.p_tags});
            }
        }
        if (typeof data.p_deleted !== 'undefined' && data.p_deleted !== null ) {
            if (Array.isArray(data.p_deleted)) {
                data.p_deleted.map((item) => {
                    search.push({param: 'p_deleted[]', value: '' + item});
                });
            } else {
                search.push({param: 'p_deleted', value: '' + data.p_deleted});
            }
        }
        const queryBody = '';
        return this.base.send('get', path, queryBody, headers, search);
    }

}
